var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonationSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0164 23.3626C24.6631 21.6926 27.7241 22.1117 29.3621 22.5894C29.4674 22.6201 29.5781 22.5655 29.6137 22.4618C29.7696 22.0071 30.1616 20.8064 30.2657 19.9441C30.3651 19.1202 30.2818 17.9403 30.2332 17.3954C30.2174 17.2183 30.0861 17.0749 29.9119 17.0395L23.0892 15.6558C22.9896 15.6356 22.8866 15.6404 22.7893 15.6698L14.0244 18.3219C13.6173 18.445 13.2408 18.6846 13.0626 19.0708C12.954 19.3061 12.8738 19.5768 12.9278 19.8008C12.9863 20.0435 13.1894 20.2428 13.394 20.3882C13.6965 20.6031 14.083 20.6279 14.4429 20.538C15.1535 20.3604 16.2052 20.0492 16.9194 19.8008C17.9659 19.4368 19.1865 19.5142 19.3553 19.5142C19.5191 19.5142 21.6274 19.678 21.914 19.6985C22.2006 19.7189 22.172 20.0341 22.0982 20.1079C22.0164 20.1897 21.8404 20.1722 21.7093 20.1693C20.7882 20.1488 18.647 19.9555 18.0248 20.0047C17.4025 20.0538 15.159 21.11 13.8899 21.11C12.8524 21.11 7.13622 18.0326 5.08444 16.9093C4.62194 16.6561 4.05055 16.615 3.6278 16.9301C3.52727 17.005 3.43817 17.0836 3.37868 17.1602C3.33651 17.2145 3.2984 17.2827 3.26409 17.3593C2.98287 17.9871 3.41075 18.6721 4.02815 18.9754L15.5819 24.6516C15.8031 24.7602 16.0421 24.8281 16.2873 24.8518L17.3338 24.9531C17.6535 24.984 17.976 24.9393 18.2752 24.8225L22.0164 23.3626Z",
    fill: "url(#paint0_linear_6972_15690)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8268 15.1723L14.0501 17.7618C13.9354 17.7956 13.8065 17.7746 13.707 17.7082C4.61347 11.6325 12.9952 2.90947 17.4925 9.23834C21.4994 3.51118 28.2074 9.98858 24.0471 15.1013C23.9585 15.2101 23.8153 15.2641 23.6766 15.243L23.0929 15.1541C23.004 15.1406 22.9131 15.1468 22.8268 15.1723Z",
    fill: "#3AA4AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3496 17.0577L12.8421 18.2848C12.8697 18.2984 12.9027 18.2953 12.9273 18.2769L13.2071 18.067C13.2514 18.0338 13.2507 17.9671 13.2056 17.9349L11.5391 16.7423C11.2555 16.5394 10.8745 16.5383 10.5897 16.7397L10.3385 16.9174C10.2878 16.9533 10.2939 17.0303 10.3496 17.0577Z",
    fill: "url(#paint1_linear_6972_15690)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63154 17.223L12.3058 19.9427C12.3632 19.9703 12.4295 19.9247 12.4259 19.8612C12.4171 19.7084 12.4098 19.4654 12.4362 19.2888C12.4664 19.0868 12.5643 18.8132 12.6129 18.6851C12.6283 18.6446 12.6104 18.5987 12.5713 18.5801L8.27452 16.5286C7.66215 16.2362 6.92787 16.4552 6.5757 17.0353C6.53516 17.1021 6.56109 17.1893 6.63154 17.223Z",
    fill: "url(#paint2_linear_6972_15690)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6972_15690",
    x1: 16.6561,
    y1: 15.625,
    x2: 16.6561,
    y2: 25.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59412E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#503B2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6972_15690",
    x1: 11.7613,
    y1: 16.4033,
    x2: 11.7613,
    y2: 18.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59412E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#503B2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6972_15690",
    x1: 9.57046,
    y1: 16.0137,
    x2: 9.57046,
    y2: 20.0053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59412E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#503B2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonationSvg);
export default __webpack_public_path__ + "static/media/DonationSVG.4c4fa1a064181e567f05845da92142e9.svg";
export { ForwardRef as ReactComponent };